<div>
  <div [ngClass]="{'hideOffScreen': !(view$ | async)}" class="resource-screen">
    <div class="resource-box">
      <button class="close-resource" mat-raised-button (click)="viewToggle(false)">Cerrar</button>
      <app-resource-viewer [unsafeUrl$]="url$" [origen]="origen" [store]="store" class="resource-box"></app-resource-viewer>
    </div>
  </div>
</div>
